/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ServiceDrivenFieldViewer} from "./ServiceDrivenFieldViewer";
import {service as PermitService} from "../../../Services/PermitService";
import React, {
	useState
} from "react";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";
import {useFetchServiceModel} from "../../../Hooks/ServiceHooks";
import {PermitModal} from "../../../Components/Modals/PermitModal";

const _PermitFieldViewer = ServiceDrivenFieldViewer(PermitService);

export const PermitFieldViewer = (props) => {
	const {Value: permitId} = props;
	
	const [showPermitModal, setShowPermitModal] = useState(false);
	const permit = useFetchServiceModel(PermitService, permitId);

	return <div className="sb-autocomplete-item">
		<PermitModal
			permit={permit}
			editable={false}
			show={showPermitModal}
			onHide={() => setShowPermitModal(false)}
		/>
		<a className="link-primary"
		   onClick={() => setShowPermitModal(true)}>
			<_PermitFieldViewer
				{...props}
				Value={permitId}
			/>
		</a>
	</div>
}